import _objectSpread from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread({}, utils, platform);